"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ApproveAs = _interopRequireDefault(require("../KnockTypeButtons/ApproveAs/ApproveAs"));
var _ActionItemTooltip = _interopRequireDefault(require("../ActionItemTooltip/ActionItemTooltip"));
var _Deny = _interopRequireDefault(require("../KnockTypeButtons/Deny/Deny"));
var _KnockItemFooter = require("./KnockItemFooter.styled");
var _SceneLayouts = require("../../../../constants/SceneLayouts");
var _KnockTypes = require("../../../../constants/KnockTypes");
var _hooks = require("../../../../hooks");
var _logger = require("@studio/logger");
var _useTranslate2 = require("../../../../locales/useTranslate");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var voidy = function voidy() {};
var KnockItemFooter = function KnockItemFooter(_ref) {
  var knockId = _ref._id,
    type = _ref.type,
    presenterName = _ref.presenterName,
    _ref$sources = _ref.sources,
    sources = _ref$sources === void 0 ? [] : _ref$sources,
    _ref$allSources = _ref.allSources,
    allSources = _ref$allSources === void 0 ? [] : _ref$allSources,
    onApprove = _ref.onApprove,
    onDeny = _ref.onDeny,
    maxCamerasExceeded = _ref.maxCamerasExceeded,
    onAssignKnockToSource = _ref.onAssignKnockToSource,
    isDisabled = _ref.isDisabled,
    assignedSourceId = _ref.sourceId;
  var handleApprove = maxCamerasExceeded ? function () {} : onApprove;
  var shouldDisableCameraKnock = type === _KnockTypes.CAMERA && maxCamerasExceeded;
  var _useTranslate = (0, _useTranslate2.useTranslate)(),
    translate = _useTranslate.translate;
  var isStudioLite = (0, _hooks.useStudioLiteContext)();
  var isButtonDisabled = shouldDisableCameraKnock || isDisabled;
  if (typeof maxCamerasExceeded !== 'boolean') maxCamerasExceeded = false;
  var handleAssignKnockToSource = (0, _react.useCallback)(function (sourceId) {
    onAssignKnockToSource && onAssignKnockToSource(sourceId);
  }, [onAssignKnockToSource]);
  var getToolTipMessage = function getToolTipMessage() {
    return isButtonDisabled ? translate('ScreenShareCount_Popover') : translate('KnockApproveButton_Popover');
  };
  var actionItemTooltipMessage = shouldDisableCameraKnock ? "".concat(_SceneLayouts.CAMERA_PRESENTER_LIMIT, "/").concat(_SceneLayouts.CAMERA_PRESENTER_LIMIT, " cameras are already active.") : getToolTipMessage();
  var handleApproveClick = function handleApproveClick(onApprove, presenterName) {
    var speakerData = {
      action: 'approve',
      name: presenterName
    };
    (0, _logger.sendToDatadog)('ApproveAs', {
      speakerData: speakerData
    }, "Approve button clicked for speaker: ".concat(presenterName));
    onApprove();
  };
  return _react["default"].createElement(_KnockItemFooter.KnockItemFooterContainer, {
    isStudioLite: isStudioLite,
    key: knockId
  }, [_KnockTypes.CAMERA].includes(type) ? _react["default"].createElement(_ActionItemTooltip["default"], {
    target: "speak-request-".concat(knockId),
    message: actionItemTooltipMessage,
    placement: "bottom"
  }, _react["default"].createElement(_KnockItemFooter.StyledButton, {
    color: "primary",
    onClick: handleApprove,
    id: "speak-request-".concat(knockId),
    $isDisabled: isButtonDisabled
  }, "Approve")) : !isStudioLite ? _react["default"].createElement(_ActionItemTooltip["default"], {
    target: "approve-as-".concat(knockId),
    message: getToolTipMessage(),
    key: "approve-as-tooltip-".concat(knockId)
  }, _react["default"].createElement(_ApproveAs["default"], {
    key: knockId,
    assignedSourceId: assignedSourceId,
    sources: sources,
    allSources: allSources,
    onApprove: onApprove,
    name: presenterName,
    knockType: type,
    onAssignKnockToSource: handleAssignKnockToSource,
    elementId: "approve-as-".concat(knockId),
    isDisabled: isButtonDisabled
  })) : _react["default"].createElement(_ActionItemTooltip["default"], {
    target: "approve-".concat(knockId),
    message: actionItemTooltipMessage,
    placement: "bottom"
  }, _react["default"].createElement(_KnockItemFooter.StyledButton, {
    "data-testid": "approve-".concat(presenterName, "-").concat(knockId),
    color: "primary",
    onClick: isDisabled ? voidy : function () {
      return handleApproveClick(onApprove, presenterName);
    },
    id: "approve-".concat(knockId),
    $isDisabled: isButtonDisabled
  }, "Approve")), _react["default"].createElement(_ActionItemTooltip["default"], {
    target: "deny-button-".concat(knockId),
    message: translate('KnockDenyButton_Popover'),
    noPointerEvent: true
  }, _react["default"].createElement(_Deny["default"], {
    onDeny: onDeny,
    elementId: "deny-button-".concat(knockId)
  })));
};
KnockItemFooter.propTypes = {
  _id: _propTypes["default"].string.isRequired,
  type: _propTypes["default"].string.isRequired,
  presenterName: _propTypes["default"].string,
  sources: _propTypes["default"].array,
  allSources: _propTypes["default"].array,
  onApprove: _propTypes["default"].func.isRequired,
  onDeny: _propTypes["default"].func.isRequired,
  maxCamerasExceeded: _propTypes["default"].bool,
  socketId: _propTypes["default"].string,
  onAssignKnockToSource: _propTypes["default"].func,
  isDisabled: _propTypes["default"].bool,
  sourceId: _propTypes["default"].string
};
var _default = exports["default"] = KnockItemFooter;